import { useState } from 'react';

interface ImageGalleryProps {
  images: string[];
  productName: string;
}

export default function ImageGallery({ images, productName }: ImageGalleryProps) {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <div className="flex flex-col gap-3 md:gap-4">
      {/* Main image */}
      <div className="relative aspect-square rounded-2xl overflow-hidden bg-secondary-100">
        <img
          src={images[activeIndex]}
          alt={`${productName} — view ${activeIndex + 1}`}
          className="w-full h-full object-cover object-top transition-opacity duration-300"
        />
        {/* Image counter */}
        <div className="absolute bottom-3 right-3 px-2.5 py-1 rounded-full bg-background-50/80 backdrop-blur-sm text-[10px] font-label font-medium text-foreground-600">
          {activeIndex + 1} / {images.length}
        </div>
      </div>

      {/* Thumbnails */}
      <div className="flex gap-2 md:gap-3 overflow-x-auto pb-1">
        {images.map((img, index) => (
          <button
            key={index}
            onClick={() => setActiveIndex(index)}
            className={`flex-shrink-0 w-16 h-16 md:w-20 md:h-20 rounded-xl overflow-hidden border-2 transition-all cursor-pointer ${
              index === activeIndex
                ? 'border-accent-500 shadow-sm'
                : 'border-transparent hover:border-background-300 opacity-70 hover:opacity-100'
            }`}
          >
            <img
              src={img}
              alt={`${productName} thumbnail ${index + 1}`}
              className="w-full h-full object-cover object-top"
              loading="lazy"
            />
          </button>
        ))}
      </div>
    </div>
  );
}